import { useApolloClient } from '@apollo/client';
import { useSearchDistance } from 'common/hooks/useZipCodeValidation';
import wsCookies from 'common/tools/ws-cookies';
import { SelectOption } from 'common/types/select-option';
import { useCarKeys } from 'data/useCarKeys';
import { USERS_GET_BY_ID } from 'data/UserQueries.graphql';
import { UserActionCode } from 'graphql/generated';
import React from 'react';
import { useDispatch } from 'react-redux';
import { cacheActions } from 'redux/cache.slice';
import { newListingMetaActions } from 'redux/new-listing-meta.slice';

const AppInitializer = () => {
  const dispatch = useDispatch();
  const client = useApolloClient();

  const [runOnce, runOnceTo] = React.useState(true);
  const { searchDistanceInit } = useSearchDistance(undefined);
  const { getYears } = useCarKeys();

  const buildStaticSelectors = React.useCallback(async () => {
    const initYearOption = { id: '', label: '' };
    const data = await getYears();
    const options: SelectOption[] = [initYearOption];
    for (const x of data) {
      options.push({ id: x.toString(), label: x.toString() });
    }
    dispatch(newListingMetaActions.yearOptions(options));
  }, [dispatch, getYears]);

  const loadUserCookie = React.useCallback(async () => {
    const id = wsCookies.get('userId');
    if (id) {
      const { data } = await client.query({
        query: USERS_GET_BY_ID,
        variables: { id, login: true },
      });
      if (data?.usersGetById?.user) {
        const { __typename, ...user } = data?.usersGetById?.user;
        if (data?.usersGetById.code === UserActionCode.loggedIn) dispatch(cacheActions.user(user));
      }
    }
  }, [client, dispatch]);

  React.useEffect(() => {
    const initialize = async () => {
      // console.log('initializing');
      await loadUserCookie();
      await searchDistanceInit();
      await buildStaticSelectors();
    };
    if (runOnce) {
      runOnceTo(false);
      initialize();
    }
  }, [runOnce, loadUserCookie, searchDistanceInit, buildStaticSelectors]);

  return null;
};

export default AppInitializer;
